import React from 'react';
import { Card, HideOnMobile, HideOnTablet } from 'quanta-ui';
import { FINANCER_DROPDOWN_DETAILS, GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS } from '../queries';
// import { Error, Loading } from '../../../../../lib/layout';
import { Error, Loading } from 'quanta-flows/modules/layout';
import RenewProposalSummary from './renew-proposal-summary-panel';
import { useQuery } from '@apollo/client';

export default function RenewViewPolicySummaryPanel(props) {
  const { loading, error, data } = useQuery(
    GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS,
  );
  const { loading: loadingFinancerDropDownDetails, error: errorFinancerDropdownDetails, data: dataFinancerDropdownDetails} = useQuery(FINANCER_DROPDOWN_DETAILS,{
    variables: {
      productCode: props?.productCode ? `${props?.productCode}`:''
    },
    fetchPolicy: 'cache-first'
  });

  if (loading || loadingFinancerDropDownDetails) {
    return <Loading />;
  }
  if (error || errorFinancerDropdownDetails) {
    return <Error error={error || errorFinancerDropdownDetails} />;
  }
  return (
    <div className="flex flex-col justify-start h-auto sticky top-0">
      <HideOnMobile className="w-full">
        <HideOnTablet className="w-full">
          <Card
            className={`h-full xl:h-auto p-0 m-0`}
            title="Renewal Proposal"
          >
            {data &&
              (!data?.viewRenewMotorPolicy ||
                !data?.viewRenewMotorPolicy?.proposalNumber) && (
                <div className="min-h-screen">
                  <Loading />
                </div>
              )}
            {data &&
              data?.viewRenewMotorPolicy &&
              data?.viewRenewMotorPolicy?.proposalNumber && (
                <RenewProposalSummary data={data} dataFinancerDropdownDetails={dataFinancerDropdownDetails} {...props} />
              )}
          </Card>
        </HideOnTablet>
      </HideOnMobile>
      <div className="xl:hidden w-full">
        {data &&
          data?.viewRenewMotorPolicy &&
          data?.viewRenewMotorPolicy?.proposalNumber && (
            <RenewProposalSummary data={data} dataFinancerDropdownDetails={dataFinancerDropdownDetails} {...props} />
          )}
      </div>
    </div>
  );
}
